//編集コード
window.addEventListener("DOMContentLoaded", function () {
  let swiperThumbnail = new Swiper(".swiper-thumbnail", {
    slidesPerView: 3,
    // spaceBetween: 19,
    freeMode: true,
    watchSlidesProgress: true,
  });

  //detailSwiperMainのベースとなるパラメータ
  const baseParams = {
    loop: true,
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiperThumbnail,
    },
  };

  // baseParams の初期化後に thumbs にアクセスする
  if (baseParams.thumbs && baseParams.thumbs.swiper) {
    const thumbsSwiper = baseParams.thumbs.swiper;
  }

  //レスポンシブ用パラメータ
  //スマホ用
  const mobileParams = {
    ...baseParams,
    effect: 'slide',
    slidesPerView: 1,  // ← 1.5 を 1 に変更
    spaceBetween: 0,   // ← 30 を 0 に変更（お好みで）
    centeredSlides: true,
  }

  //パソコン用
  const desktopParams = {
    ...baseParams,
    effect: "fade",
    slidesPerView: 1,
  };

  let detailSwiperMain = null;
  const mql = window.matchMedia("screen and (max-width: 768px)");

  function rewrite(mql) {
    if (detailSwiperMain) {
      detailSwiperMain.destroy(true, true);
    }
    if (swiperThumbnail) {
      swiperThumbnail.destroy(true, true);
    }

    const currentParams = mql.matches ? mobileParams : desktopParams;
    swiperThumbnail = new Swiper(".swiper-thumbnail", {
      slidesPerView: 3,
      // spaceBetween: 19,
      freeMode: true,
      watchSlidesProgress: true,
    });

    detailSwiperMain = new Swiper(".detail-swiper-main", {
      ...currentParams,
      thumbs: {
        swiper: swiperThumbnail,
      },
    });
  }

  mql.addEventListener("change", rewrite);
  rewrite(mql);

  // おすすめ商品の画像スライダー初期化
  initializeProductSliders();
});

// 商品カードのスライダーを初期化する関数
function initializeProductSliders() {
  const allSliders = Array.from(
    document.querySelectorAll(".common_products_list_product_slider")
  );

  allSliders.forEach((slider) => {
    const figure = slider.querySelector("figure");
    const parentId = slider.getAttribute("title");
    const parentElement = document.getElementById(parentId);

    if (!parentElement) {
      console.warn("Parent element not found:", parentId);
      return;
    }

    const prevBtn = parentElement.querySelector(".prev_btn");
    const nextBtn = parentElement.querySelector(".next_btn");
    const paginationWrap = parentElement.querySelector(
      ".common_products_list_product_slider_pagination"
    );

    if (figure && figure.children.length > 1 && prevBtn && nextBtn) {
      if (typeof generateLoopSliderDirect === 'function') {
        generateLoopSliderDirect(figure, prevBtn, nextBtn, paginationWrap);
      } else {
        console.warn('generateLoopSliderDirect is not available.');
      }
    }
  });
}

const form = document.querySelector("#add_cart_form");

const submitAddCart = () => {
  form.submit();
};

// アコーディオンの処理

const detailCount = document.querySelector(".detail_count");
const detailDecrease = document.querySelector(".detail_decrease");
const detailIncrease = document.querySelector(".detail_increase");

let count = 0;

function updateCounter() {
  detailCount.textContent = count;
  form.querySelector("input[name=quantity]").value = count;
}

detailIncrease.addEventListener("click", () => {
  count++;
  updateCounter();
});
detailDecrease.addEventListener("click", () => {
  if (count > 0) {
    count--;
    updateCounter();
  }
});

// アニメーションの時間とイージング
const animTiming = {
  duration: 300,
  easing: "ease-in-out",
};

const closingAnimation = (answer) => [
  {
    height: answer.scrollHeight + "px", // 正しい高さを取得
    opacity: 1,
  },
  {
    height: 0,
    opacity: 0,
  },
];

const openingAnimation = (answer) => [
  {
    height: 0,
    opacity: 0,
  },
  {
    height: answer.scrollHeight + "px", // 正しい高さを取得
    opacity: 1,
  },
];

// ボタンのホバー時の色の変化
const detailPaths = document.querySelectorAll(".detail_icon_path");
const detailButton = document.querySelector(".detail_button");
detailButton.addEventListener("mouseover", () => {
  detailPaths.forEach((e) => {
    e.setAttribute("stroke", "#c94829");
  });
});
detailButton.addEventListener("mouseout", () => {
  detailPaths.forEach((e) => {
    e.setAttribute("stroke", "white");
  });
});
